<template>
<!--:class="{invalid: invalid}"-->
  <div class="area-box" :class="{invalid: invalid}"  @click="handleClick">
    <div class="img-area">
      <img :src='currentIconSrc' >
    </div>
    <div class="text-area" >
      <h4 class="text-name"><span class="number" v-if="missionId<14">{{missionId}}</span>{{missionName}}</h4>
      <!-- <h5 class="text-name2"><span class="number2" v-if="missionId<14">完成人数:</span>{{finishcount}}人</h5> -->
    </div>
    <div :class="statusClass" v-show="finished"><p>{{text}}</p></div>
    <div v-if="invalid" class="disabled">
       <i class="iconfont icon-lock" title="禁用"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaBox',
  props: {
    missionId: Number,
    missionName: String,
    activeUserCount: Number,
    invalid: Boolean,
    finish: String,
    finishcount: String, 
  },
  data () {
    return {
      statusClass:'finish',
      finished:false,
      text:'完成'
    }
  },
  computed: {
		currentIconSrc() {
      return 'http://sys.rennengda.com/public/images/mission/mission-icon-' + this.missionId+ '.gif'
		},
  },
  created(){
    this.isFinished()
  },
  methods: {
    isFinished() {
      if(this.finish==='1'){
        this.finished = true
      }else if(this.finish==='-1'){
        this.statusClass = 'unfinished'
        this.finished = true,
        this.text = '失败'
      }
    },
    handleClick() {
      if(this.invalid){
       this.$message({
          message: '请完成关卡'+(this.missionId-1)+'，才能解锁',
          type: 'warning',
          center: true
        });
      }else{
        this.$emit('playMission',this.missionId)
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.area-box
  background-color:#D5F1FC
  margin:0.2rem 0.1rem
  overflow:hidden
  border-radius:0.24rem
  position:relative
.img-area
  float:left
  margin:0.1rem 0.1rem

.img-area
  img
    width:0.84rem
    height:0.84rem
.text-area
    float:left
    font-size:0.24rem;
    width:60%
    .gray
      color:#777777
    .number
      font-size :0.36rem
      // font-weight :bold
    .number2
      font-size :0.2rem;
    h4
        font-size:0.28rem
        margin-top: 0.2rem
        line-height: 0.28rem
        width: 100%
    .text-name
        margin-top:0.3rem
        font-size:0.32rem
    .text-name2
        margin-top:0.1rem
        font-size:0.2rem     
    .countInfo
      color:#DC6E5A

.finish,.unfinished
  position:relative
  height: 1rem
  font-size: 0.6rem
  color: #E13716
  p
    position:absolute
    margin:0
    transform: rotate(22deg)
    top: 0.3rem
    // left: 1.4rem
    right: 0.2rem
    opacity: 0.7
.unfinished
  color: #00B3DE
.invalid
  filter:Gray

 .disabled
  position:absolute
  bottom:0.05rem
  left:1rem
  color:#777777
  transform:rotate(45deg)
  opacity:0.7
  i
    font-size:1.2rem
</style>
